
<div class="cp-rule">
  <div class="close" @click="handleClose"></div>
  <div class="rule">
  </div>
</div>
